import { render, staticRenderFns } from "./translation-job-analyze-modal.vue?vue&type=template&id=03f68971"
import script from "./translation-job-analyze-modal.vue?vue&type=script&lang=ts"
export * from "./translation-job-analyze-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports